const mapBoxToken: string = 'pk.eyJ1Ijoic2hhbmUtYXhpb20iLCJhIjoiQTQ1U0FpTSJ9.vHiaSADEGTCnUJPZR5HZcg'
const getToken = (): string => { return mapBoxToken }
export { getToken }
